import React, { useEffect, useState } from 'react';
import './userlist.css';
import ListHealth from './Components/ListHealth';
import { getHotkeyStore, processMouseCommand } from './store/hotkeyStore';
import { usePlayerStore } from './store/store';
import useUserBuffStore from './store/userBuffStore';
import UserListBuff from './Components/UserListBuff';

function UserListElement({ pos, details, sendMessage, displayModal, displayMenu }) {
    // Get player info for character ID
    const playerInfo = usePlayerStore((state) => state.pInfo);
    const characterId = playerInfo?.name;
    
    // Get buffs for this user from the buff store
    const getBuffs = useUserBuffStore((state) => state.getBuffs);
    const targetId = details.type === 'player' ? details.name : details.id;
    const userBuffs = getBuffs(targetId);
    
    // Store ctrl+click options
    const [ctrlClickOptions, setCtrlClickOptions] = useState({
        leftClick: { name: "Attack", cmd: "/a {target}" },
        rightClick: { name: "Examine", cmd: "/examine {target}" }
    });
    
    // Load ctrl+click options from store when character ID changes
    useEffect(() => {
        if (characterId) {
            const store = getHotkeyStore(characterId);
            if (store) {
                // Get initial options
                const storedCtrlClickOptions = store.getState().ctrlClickOptions;
                if (storedCtrlClickOptions) {
                    setCtrlClickOptions(storedCtrlClickOptions);
                }
                
                // Subscribe to changes in the store
                const unsubscribe = store.subscribe((state) => {
                    if (state.ctrlClickOptions) {
                        setCtrlClickOptions(state.ctrlClickOptions);
                    }
                });
                
                // Clean up subscription when unmounting
                return () => unsubscribe();
            }
        }
    }, [characterId]);

    const train = (action) => {
        sendMessage("316" + details.id + ';' + action);
        if (action === 'learn') {
            displayModal('trainer');
        }
        if (action === 'shop') {
            displayModal('shop');
        }
    }

    const border = () => {
        switch (details.attacking) {
            case 0: return " default-border";
            case 1: return " aggro-border blinking";
            case 2: return " aggro-party-border";
            default:
                break;
        }
    }

    const status = (status) => {
        switch (status) {
            case 0: return '#A9AAB0'
            case 1: return '#4DBA09';
            case 2: return '#BD0404';
            default:
                return '#BBDDEE';
        }
    }

    const selected = (e) => {
        // Handle ctrl+left click
        if (e.ctrlKey) {
            e.preventDefault();
            e.stopPropagation();
            handleCtrlClick('leftClick');
            return;
        }
        
        // Normal selection
        sendMessage('345' + (details.type === 'mob') + '/' + details.id)
    }
    
    const handleContextMenu = (e) => {
        // Handle ctrl+right click
        if (e.ctrlKey) {
            e.preventDefault();
            e.stopPropagation();
            handleCtrlClick('rightClick');
            return;
        }
        
        // Normal context menu
        displayMenu(e, pos, details);
    }
    
    const handleCtrlClick = (clickType) => {
        const option = ctrlClickOptions[clickType];
        if (option && option.cmd) {
            const processedCommand = processMouseCommand(option.cmd, pos, details.name);
            if (processedCommand) {
                sendMessage('600' + processedCommand);
            }
        }
    }

    const startChat = () => {
        // Send chat command using position (same as right-click context menu chat)
        sendMessage('600/t ' + pos + ' hi');
    }

    const classNames = 'userlist-element' + border() + (details.selected ? ' user-selected ' : ' user-default');

    return (
        <>
            <div 
                className={classNames} 
                onClick={e => selected(e)} 
                onContextMenu={handleContextMenu}
                title={`Ctrl+Click for quick actions`}
            >
                {details.type === 'mob' && (
                    <span 
                        className="chat-bubble" 
                        onClick={(e) => {
                            e.stopPropagation(); // Prevent triggering the div's onClick
                            startChat();
                        }}
                        title={`Chat with ${details.name}`}
                    >
                        💬
                    </span>
                )}
                <div className='portrait'>
                    <img src={require('./Assets/gfx/' + details.picId + '.webp')} alt='' onError={(e)=> {e.target.src ="./Assets/gfx/1.webp"}}/>
                    <p>Lv. {details.level}</p>
                </div>
                <div className={'userlist-details'}>
                    <p style={{ color: status(details.friend) }}>{pos}. {details.type === 'player' && ' (Player)'} {details.name}</p>
                    <div className='mid'>
                        {/* Display user buffs on the left */}
                        {userBuffs.length > 0 && (
                            <div 
                                className="user-list-buffs" 
                                data-hidden-count={userBuffs.length > 8 ? userBuffs.length - 8 : 0}
                            >
                                {userBuffs.slice(0, 8).map((buff) => (
                                    <UserListBuff key={buff.uuid} buff={buff} />
                                ))}
                            </div>
                        )}
                        {details.actions && details.actions.length > 0 && details.actions.toReversed().map(action => (<button key={action} onClick={() => train(action)}>{action.charAt(0).toUpperCase() + action.slice(1)}</button>))}
                    </div>
                    <div className='user-hp'>
                        {<ListHealth hp={details.hp} />}
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserListElement;